<template>
  <div class="feedback">
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item label="分类">
        <el-select
          v-model="form.problemCategory"
          clearable
          placeholder="请选择分类"
          @clear="clear"
        >
          <el-option
            v-for="(item, index) in optionList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="onSubmit" class="btnBackgory">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="width: 100%"  v-loading="loading">
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="phone"
        label="电话"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="wechat"
        label="微信"
        align="center"
        min-width="120"
      />
      <el-table-column prop="imgId" label="图片" align="center" min-width="180">
        <template #default="scope">
          <div>
            <img
              v-for="item in scope.row.imgId"
              :key="item"
              style="width: 50px; height: 50px; margin-right: 5px"
              :src="`${uploadUrl}+${item}`"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="problemCategory"
        label="分类"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="productName"
        label="产品名称"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="shopName"
        label="店铺名称"
        align="center"
        min-width="120"
      />
      <el-table-column prop="remark" label="留言" min-width="180" />
      <el-table-column
        label="操作"
        min-width="100"
        align="center"
        fixed="right"
      >
        <template #default="scope">
          <div class="operate">
            <el-popconfirm
              title="您确认要删除该条数据吗？"
              @confirm="deleteOnly(scope.row)"
            >
              <div slot="reference" class="btn">删除</div>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageContainer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        layout="total, prev, pager, next,sizes"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "feedback",
  data() {
    return {
      form: {
        problemCategory: ""
      },
      uploadUrl: "",
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },

      total: 0,
      optionList: [
        {
          value: "产品",
          label: "产品"
        },
        {
          value: "门店",
          label: "门店"
        },
        {
          value: "售后",
          label: "售后"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      tableData: []
    };
  },
  mounted() {
    this.uploadUrl = apis.uploadUrl;
    this.getFeedbackList();
  },
  methods: {
    // 获取列表
    getFeedbackList() {
      const json = {
        problemCategory: this.form.problemCategory,
        ...this.pageData
      };
      this.loading = true;
      apis.queryFeedback(json).then(res => {
        if (res.code === 200) {
          this.loading = false;
          this.total = res.data.totalElements;
          this.tableData = res.data.content.map(item => {
            item.imgId = item.imgId.split(",");
            return item;
          });
        }
      });
    },
    // 清空
    clear() {
      this.getFeedbackList();
    },
    //搜索
    onSubmit() {
      this.getFeedbackList();
    },
    //删除
    deleteOnly(row) {
      apis.deleteFeedback(row.id).then(res => {
        if (res.code === 200) {
          console.log(res);
          this.getFeedbackList();
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getFeedbackList();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getFeedbackList();
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback {
  padding: 30px;
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
    border: 0;
  }
  .pageContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>
